module.exports = __webpack_public_path__ + "img/businessLicense1.0272167b.png";